import AddIcon from '@mui/icons-material/Add';

import s from './AddButton.module.css';

type Props = {
  label?: string;
  handleClick: () => void;
};

function AddButton({ label, handleClick }: Props) {
  return (
    <button type="button" className={s.addButton} onClick={handleClick}>
      <AddIcon />
      {label && <span className={s.labelText}>{label}</span>}
    </button>
  );
}

export default AddButton;
